import { getPublishedVersions } from './versions.action';
export { versionsReducer } from './versions.reducer';
export { watchVersions } from './versions.saga';

export const versionsActions = {
    getPublishedVersions,
};
